import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
} from "@mui/material";
import axios from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getUIDescription } from "./customerGroupDetails/AssigningCustomerGroupDevice";

export default function EditGroupForm({ open, onClose, onSubmit, groupData }) {
  const PREFIX = "PRC - ";

  // Pre-populate fields with existing group data
  const [groupName, setGroupName] = useState("");
  const [groupId, setGroupId] = useState("");
  const [description, setDescription] = useState("");

  // 🔹 State for groups
  const [groups, setGroups] = useState([]);

  const [loading, setLoading] = useState(false);

  // 🔹 Pre-populate form fields when groupData changes
  useEffect(() => {
    if (groupData) {
      setGroupId(groupData.id || "");

      // Always remove prefix if it exists (case-insensitive)
      let nameWithoutPrefix = groupData.name || "";
      const lowerName = nameWithoutPrefix.toLowerCase();
      const lowerPrefix = PREFIX.toLowerCase();

      if (lowerName.startsWith(lowerPrefix)) {
        nameWithoutPrefix = nameWithoutPrefix.substring(PREFIX.length);
      }

      setGroupName(nameWithoutPrefix);
      setDescription(groupData.description || "");
    }
  }, [groupData]);

  // Full name with prefix
  const fullName = PREFIX + groupName;

  const handleUpdateGroup = async () => {
    try {
      setLoading(true);
      const payload = {
        name: fullName, // Send with prefix
        description: description || "",
        UI_Description: `${getUIDescription()}\n Update Group`,
      };

      const response = await axios.put(
        `${process.env.REACT_APP_API_GATEAWAY}/groups/${groupData.id}`,
        payload
      );

      console.log("✅ Group updated:", response.data);

      // Call the parent's onSubmit callback if provided
      if (onSubmit) {
        onSubmit(response.data);
      }
      toast.success("✅ Group updated successfully!");
    } catch (error) {
      console.error(
        "❌ Error updating group:",
        error.response?.data || error.message
      );
      toast.error(error.response?.data?.message || "❌ Failed to update group");
    } finally {
      setLoading(false);
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Group</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            label="Group Name"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Box sx={{ color: "text.secondary", fontWeight: 500 }}>
                    {PREFIX}
                  </Box>
                </InputAdornment>
              ),
            }}
            helperText={
              groupName ? `Full name: ${fullName}` : "Enter group name"
            }
          />

          {/* 🔹 Description */}
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Cancel
        </Button>
        <Button
         
           sx={{
                borderRadius: 0, // ✅ remove rounding
            }}
          onClick={handleUpdateGroup}
          variant="contained"
          color="primary"
          disabled={loading || !groupName}
        >
          {loading ? "Updating..." : "Update Group"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
